import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
const steps = [{
  title: "Send your nameplate/marking spec & volumes",
  description: "Product marking requirements, materials, data fields, branding, and annual/per-release volumes; or a drawing and sample."
}, {
  title: "Quote & program terms",
  description: "Material/method, per-unit and release pricing, lead times, and the reorder process."
}, {
  title: "Approve a first article",
  description: "Evermark produces a first article; material, layout, content, branding, and serialization confirmed and locked."
}, {
  title: "Standing production",
  description: "Releases produce to the locked first article on your schedule, with variable data marked from your sequence and in-process checks."
}, {
  title: "Reorder & maintain",
  description: "The approved program stays on file; reorders match the original, and changes are revision-controlled. {{verify: revision-control / change process}}."
}];
export default function HowToSetUpAProgram() {
  return <section id="how-to-set-up-a-program" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            How Do You Set Up an OEM Marking Program?
          </h2>
          <p className="text-lg text-muted-foreground">
            Setting up an OEM program with Evermark Industrial Solutions follows
            a five-step path built around a first article and a standing release
            process.
          </p>
        </div>

        <div className="grid gap-6 md:gap-8">
          {steps.map((step, i) => <Card key={i} data-index={i} className="flex flex-col md:flex-row items-start md:items-center gap-6 p-6 md:p-8 border-border/50 shadow-sm hover:shadow-md transition-shadow">
              <div className="text-6xl md:text-7xl font-bold text-primary font-default leading-none shrink-0 opacity-90">
                0{i + 1}
              </div>
              <div className="flex-1">
                <h3 className="text-xl md:text-2xl font-semibold font-default text-card-foreground mb-2">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </div>
            </Card>)}
        </div>

        <div className="mt-12 md:mt-16 text-center">
          <Button asChild size="lg" className="text-base h-12 px-8">
            <Link to="/ContactPage">
              Set Up an OEM Program
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}